import { BedDouble, PackageOpen, Snowflake,Shirt  } from "lucide-react";


export default function AmenitiesSection({ amenities }: any) {
  const icon: any = {
    Wifi: "📶",
    Pileta: "🏊",
    Televisor: "📺",
    Estacionamiento: "🚗",
    Cocina: "🍳",
    Refrigerador: Snowflake,
    "Ropa de cama": BedDouble,
    Perchas: Shirt,
    "Espacio para guardar ropa": PackageOpen,
  };
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">¿Qué ofrece este lugar?</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {amenities.map((amenity: any, index: number) => {
          const Icon = icon[amenity.name];
          return (
            <div
              key={index}
              className="flex items-center gap-3 p-1 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <span className="text-xl">
                {typeof Icon === "string" ? (
                  Icon // Emoji
                ) : Icon ? (
                  <Icon className="w-5 h-5" /> // React component
                ) : (
                  "❓" // Icono por defecto si no se encuentra
                )}
              </span>
              <span className="text-gray-700">{amenity.name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
